import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as a from 'actions';
import RecsFieldSetting from 'components/kea/RecsFieldSetting';
import SaveActionBtnGrp from 'components/kea/settings/SaveActionBtnGrp';
import FeaturePageShell from 'components/shell/FeaturePageShell';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import styles from './RecsFields.module.scss';

const RecsFields = () => {
  const dispatch = useDispatch();
  const localizeMessage = useLocalizedMessage();
  const { recs } = useSelector(store => store);
  const {
    fields: {
      data,
      forDiff,
      isFetching,
      isUpdating,
      error,
    },
  } = recs;

  const fields = Object.values(data || {});
  const hasChanges = JSON.stringify(data || {}) !== JSON.stringify(forDiff || {});
  const changeHandler = (id, value) => dispatch(a.fieldsDataUpdate(id, 'weight', value));
  const discard = () => dispatch(a.discardRecsFieldsSetting());
  const save = () => dispatch(a.saveRecsFields());

  const buttons = [
    {
      text: localizeMessage('common.save'),
      action: save,
      color: 'primary',
      testId: 'recs-fields-save',
    },
    {
      text: localizeMessage('common.discard'),
      action: discard,
      color: 'secondary',
      testId: 'recs-fields-discard',
    },
  ];

  return (
    <FeaturePageShell
      title={localizeMessage('recommendations.fields.title')}
      description={localizeMessage('recommendations.fields.description')}
      width="expanded"
      isLoading={isFetching && fields.length === 0}
      error={error && !isFetching ? error : null}
      actions={(
        <SaveActionBtnGrp
          isFetching={isUpdating}
          buttons={buttons}
          disabled={!hasChanges}
        />
      )}
    >
      <section className={styles.surface} data-testid="recommendation-fields-surface">
        <div className={styles.sectionHeader}>
          <div>
            <h2 className={styles.sectionTitle}>
              {localizeMessage('recommendations.fields.section.title')}
            </h2>
            <p className={styles.sectionHint}>
              {localizeMessage('recommendations.fields.section.hint')}
            </p>
          </div>
          <span className={styles.countBadge}>
            {localizeMessage('recommendations.fields.count', { count: fields.length })}
          </span>
        </div>
        <div className={styles.columnHeader}>
          <span>{localizeMessage('recommendations.fields.header.fieldName')}</span>
          <span>{localizeMessage('recommendations.fields.header.priority')}</span>
        </div>
        {fields.map(field => (
          <RecsFieldSetting
            key={field.id}
            id={field.id}
            value={field.weight}
            onChange={changeHandler}
            title={field.title}
          />
        ))}
        {fields.length === 0 && !isFetching ? (
          <div className={styles.emptyState}>
            {localizeMessage('recommendations.fields.empty')}
          </div>
        ) : null}
      </section>
    </FeaturePageShell>
  );
};

export default RecsFields;
